import * as React from "react";
import { useCallback, useState, useEffect } from "react";
import useLocation from "routing/useLocation";
import ErrorPage from "components/errors/ErrorPage";
import ErrorsActions from "actions/errors/ErrorsActions";
import {
  ReactErrorType,
  NotFoundErrorType,
  UnauthorizedErrorType,
  StreamPermissionErrorType
} from "logic/errors/ReportedErrors";
import RuntimeErrorPage from "pages/RuntimeErrorPage";
import NotFoundPage from "pages/NotFoundPage";
import UnauthorizedErrorPage from "pages/UnauthorizedErrorPage";
import StreamPermissionErrorPage from "pages/StreamPermissionErrorPage";
import useProductName from "brand-customization/useProductName";
const FallbackErrorPage = ({ reportedError }) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(
    ErrorPage,
    {
      title: "Something went wrong",
      description: /* @__PURE__ */ React.createElement("p", null, "An unknown error has occurred. Please have a look at the following message and the ", productName, " server log for more information.")
    },
    /* @__PURE__ */ React.createElement("pre", null, JSON.stringify(reportedError))
  );
};
const ReportedErrorPage = ({ reportedError }) => {
  switch (reportedError.type) {
    case ReactErrorType:
      return /* @__PURE__ */ React.createElement(RuntimeErrorPage, { error: reportedError.error, componentStack: reportedError.info.componentStack });
    case NotFoundErrorType:
      return /* @__PURE__ */ React.createElement(NotFoundPage, null);
    case UnauthorizedErrorType:
      return /* @__PURE__ */ React.createElement(UnauthorizedErrorPage, { error: reportedError.error });
    case StreamPermissionErrorType:
      return /* @__PURE__ */ React.createElement(StreamPermissionErrorPage, { error: reportedError.error });
    default:
      return /* @__PURE__ */ React.createElement(FallbackErrorPage, { reportedError });
  }
};
const ReportedErrorBoundary = ({ children }) => {
  const [reportedError, setReportedError] = useState();
  const report = useCallback((newError) => setReportedError(newError), []);
  useEffect(() => ErrorsActions.report.listen(report), [report]);
  const location = useLocation();
  useEffect(() => {
    setReportedError(void 0);
  }, [location]);
  return reportedError ? /* @__PURE__ */ React.createElement(ReportedErrorPage, { reportedError }) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export default ReportedErrorBoundary;
